import * as yup from "yup";

export const schema = yup.object({
  firstName: yup.string().required("Nombre es requerido"),
  lastName: yup.string().required("Apellido es requerido"),
  email: yup.string().email("Correo inválido").required("Correo es requerido"),
  phone: yup.string().required("Teléfono es requerido"),
  interest: yup.string().required("Selecciona un interés"),
  terms: yup.boolean().oneOf([true], "Debes aceptar los términos").required(),
}).required();

export type FormData = yup.InferType<typeof schema>;
